import FormCreator from '../../../components/shared/FormCreator/formCreator';
import { AddAllergyComponent } from './types';

const AddAllergyForm: React.FC<AddAllergyComponent> = ({
  initialValues,
  isModalOpen,
  formFieldData,
  setIsModalOpen,
  onSave,
  validationSchema,
}) => {
  return (
    <FormCreator
      initialValues={initialValues}
      isModalOpen={isModalOpen}
      formFieldData={formFieldData}
      setIsModalOpen={setIsModalOpen}
      handleSave={onSave}
      validationSchema={validationSchema}
    />
  );
};

export default AddAllergyForm;
